module.exports = __webpack_public_path__ + "static/media/traffic-event.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suttonparkbus/traffic-event.svg
// module id = 898
// module chunks = 0